import { Fragment } from 'react';
import { APP_URLS, NETWORK_MENUS } from '../config/network';
import { HeaderMenu } from './HeaderMenu';

export function NetworkMenu({ onNotice }: { onNotice: (message: string) => void }): JSX.Element {
  return <nav className="network-menu menu-bar" aria-label="Network menu">
    {NETWORK_MENUS.map((menu) => <HeaderMenu
      key={menu.label} id={`network-${menu.label.toLowerCase()}`} label={menu.label}
      popoverClassName="network-popover" align="right"
    >
      {menu.groups.map((group, index) => <Fragment key={index}>
        {index > 0 && <span className="menu-separator" />}
        {group.map((name) => name === 'ConstructCanvas' ?
          <button type="button" key={name} aria-current="page" data-network-app={name}
            onClick={() => onNotice('You are already in ConstructCanvas.')}>
            <span>{name}</span><small className="current-app-badge">Current app</small>
          </button> :
          <a key={name} href={APP_URLS[name]} target="_blank" rel="noopener noreferrer" data-network-app={name}
            title={`Open ${name} in a new tab`}><span>{name}</span></a>,
        )}
      </Fragment>)}
    </HeaderMenu>)}
  </nav>;
}
